var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5238 9.75639C12.0125 10.2453 12.0125 11.0352 11.5238 11.524C11.4078 11.6403 11.2701 11.7325 11.1184 11.7953C10.9667 11.8582 10.8041 11.8904 10.6399 11.8903C10.3199 11.8903 9.99995 11.7678 9.75614 11.524L5.99999 7.76766L2.24384 11.5241C2.1279 11.6403 1.99015 11.7325 1.83848 11.7954C1.68682 11.8582 1.52424 11.8905 1.36007 11.8903C1.19588 11.8905 1.03328 11.8582 0.881593 11.7954C0.72991 11.7325 0.592136 11.6403 0.476182 11.5241C-0.0124898 11.0352 -0.0124898 10.2453 0.476182 9.75639L4.23257 6.00023L0.476123 2.24408C-0.0125488 1.75518 -0.0125488 0.965274 0.476123 0.476426C0.965029 -0.0122457 1.75493 -0.0122457 2.24384 0.476426L5.99999 4.23281L9.75614 0.476367C10.245 -0.0123047 11.035 -0.0123047 11.5238 0.476367C12.0125 0.965273 12.0125 1.75518 11.5238 2.24408L7.76741 6.00023L11.5238 9.75639Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.541518244ec8da039a593f13b5a114a0.svg";
export { ForwardRef as ReactComponent };